import { Hotel } from '@/components/pages/event/layout/components/hotel-booking/components/hotel-cards';
import permissionless2Hotels from '@/components/pages/event/layout/components/hotel-booking/data/permissionless-hotels';

const hotelBookingMap: { [key: string]: Hotel[] } = {
    'permissionless-2023': permissionless2Hotels,
};

export default hotelBookingMap;
